module.exports = __webpack_public_path__ + "img/crystal.be5030ca.webp";